import Modal from './modal';
import { Button } from './button';

interface ConfirmModalProps {
  isOpen: boolean;
  title?: string;
  description?: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void | Promise<void>;
  onCancel: () => void;
  loading?: boolean;
}
const ConfirmModal = ({ isOpen, title = 'Confirm action', description, confirmText = 'Confirm', cancelText = 'Cancel', onConfirm, onCancel, loading = false }: ConfirmModalProps) => {
  if (!isOpen) return null;

  return (
    // While an action is in flight, ignore backdrop/close-button dismissal so it
    // stays consistent with the disabled footer Cancel button.
    <Modal isOpen={isOpen} onClose={loading ? () => undefined : onCancel} title={title} size='sm'>
      <div className='space-y-6'>
        {description && <p className='text-muted-foreground'>{description}</p>}

        <div className='flex justify-end gap-2'>
          <Button variant='ghost' onClick={onCancel} disabled={loading}>
            {cancelText}
          </Button>
          <Button variant='destructive' onClick={onConfirm} disabled={loading}>
            {confirmText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
